/**
 * Plan 10-02 D-95 — slugify a Label string into a backend-compatible custom-field
 * Key. Backend regex: `^[a-zA-Z][a-zA-Z0-9_]*$` (Plan 10-01).
 *
 * Behavior:
 *  - Lowercase + strip non-alphanumeric (replaced with `_`).
 *  - Trim leading/trailing underscores.
 *  - Empty result -> empty string (caller surfaces as Zod error).
 *  - First-char digit guard -> prefix with `f_` to keep regex valid.
 */
export function slugifyKey(label: string): string {
  if (label.length === 0) return '';
  let s = label
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
  if (s.length === 0) return '';
  if (/^[0-9]/.test(s)) s = `f_${s}`;
  return s;
}
